import { ref, watch } from 'vue';

interface FieldToTabMap {
    [key: string]: string;
}

export function useFormErrorTabs(form: any, fieldToTabMap: FieldToTabMap, defaultTab: string = '') {
    const currentTab = ref(defaultTab);

    const setTab = (tab: string) => {
        currentTab.value = tab;
    };

    watch(
        () => form.errors,
        (errors) => {
            if (errors && Object.keys(errors).length > 0) {
                const orderedFields = Object.keys(fieldToTabMap);

                const firstMatchingField = orderedFields.find((field) =>
                    Object.prototype.hasOwnProperty.call(errors, field),
                );

                if (firstMatchingField) {
                    const tabToFocus = fieldToTabMap[firstMatchingField];

                    if (tabToFocus) {
                        setTab(tabToFocus);
                    }
                }
            }
        },
        { deep: true },
    );

    return {
        currentTab,
        setTab,
    };
}
